const FLOAT_JSON_KEYS = new Set( [
  'revenue_usd',
  'revenueusd',
  'lifetime_revenue',
  'lifetimerevenue',
  'revenue_delta',
  'revenuedelta',
  'mass_attempt',
  'mass_level',
  'mass_applied',
] );

const FLOAT_MARKER = '__JSON_FLOAT__';

const toJsonFloatLiteral = ( value: number ): string =>
{
  const raw = String( value );
  return /[.eE]/.test( raw ) ? raw : `${raw}.0`;
};

export const stringifyWithForcedFloatFields = ( payload: unknown ): string =>
{
  return JSON.stringify( payload, ( key, value ) =>
  {
    if ( FLOAT_JSON_KEYS.has( key ) && typeof value === 'number' && Number.isFinite( value ) )
    {
      return `${FLOAT_MARKER}${toJsonFloatLiteral( value )}`;
    }

    return value;
  } ).replace(
    new RegExp( `"${FLOAT_MARKER}([^"]+)"`, 'g' ),
    '$1'
  );
};
